import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
// Theme switching (see src/themes/). Remove this boot entry in quasar.conf.js to disable themes.
import Vue from 'vue';
import Dark from 'quasar/src/plugins/Dark.js';;
import 'src/themes/themes.css';
import 'src/themes/themes-quasar.css';
import { THEMES, resolveInitialTheme, applyTheme, saveTheme } from 'src/themes/themes';
import { isDevEnvironment } from 'src/functions/environment'; // demo only (set from the /home demo picker): participation banner style, /home header, tile layout,
// page background and panel depth. Global so Header.vue and Home.vue share it and it survives
// navigation; saved in localStorage so it survives reloads. Remove together with the demo picker.

var DEMO_KEY = 'gm-demo'; // tile layout: Compact on every screen size (user, 1 Oct 2026; was Compact on phones, Icoon from 600px)

var DEFAULT_TILES = 'compact'; // page background depends on screen size (checked once at load, user 1 Oct 2026): phones (< 600px, Quasar xs) get
// Zacht (soft) for contrast with the white tiles, tablet/desktop Wit (plain)

var DEFAULT_BACKGROUND = typeof window !== 'undefined' && window.innerWidth < 600 ? 'soft' : 'plain'; // default (user, 1 Oct 2026): Opvallend + tekst + voortgang · Foto header · Zacht/Wit · Zacht · Compact; the theme itself stays the app default

var DEMO_DEFAULTS = {
  notice: 'boldfull',
  banner: 'photo',
  tiles: DEFAULT_TILES,
  background: DEFAULT_BACKGROUND,
  depth: 'soft'
}; // values each switcher can take (keep in sync with the demo picker in Home.vue); a saved value not
// listed here falls back to the default, so trimming an option never leaves a user without a banner

var DEMO_VALUES = {
  notice: ['progress', 'bold', 'boldprogress', 'boldfull'],
  banner: ['solid', 'photo', 'minimal', 'pass', 'welcome'],
  tiles: ['inline', 'poster', 'game', 'icon', 'compact', 'welcome'],
  background: ['plain', 'soft', 'meadow'],
  depth: ['flat', 'soft', 'deep']
}; // recommended combinations (all six switchers incl. theme), applied from the demo picker

var DEMO_PRESETS = {
  weide: {
    theme: 'modern-light',
    notice: 'progress',
    banner: 'welcome',
    background: 'meadow',
    depth: 'soft',
    tiles: 'welcome'
  },
  app: {
    theme: 'glass',
    notice: 'bold',
    banner: 'minimal',
    background: 'soft',
    depth: 'soft',
    tiles: DEFAULT_TILES
  },
  speels: {
    theme: 'modern-light',
    notice: 'progress',
    banner: 'minimal',
    background: 'plain',
    depth: 'soft',
    tiles: 'game'
  }
}; // the demo picker is dev only (D74): elsewhere nobody can change the choices, so saved ones are ignored

var loadDemo = function loadDemo() {
  if (!isDevEnvironment()) return Object.assign({}, DEMO_DEFAULTS);

  try {
    var saved = JSON.parse(window.localStorage.getItem(DEMO_KEY) || '{}') || {};
    var demo = Object.assign({}, DEMO_DEFAULTS);
    Object.keys(DEMO_VALUES).forEach(function (k) {
      if (DEMO_VALUES[k].includes(saved[k])) demo[k] = saved[k];
    });
    return demo;
  } catch (e) {
    return Object.assign({}, DEMO_DEFAULTS);
  }
};

export default (function () {
  var theme = Vue.observable({
    list: THEMES,
    current: applyTheme(resolveInitialTheme(), Dark),
    demo: loadDemo()
  }); // Explicit user choice from the switcher: apply + persist

  theme.set = function (name) {
    theme.current = applyTheme(name, Dark);
    saveTheme(theme.current);
  }; // demo only: recommended combinations


  theme.presets = Object.keys(DEMO_PRESETS);

  theme.matchesPreset = function (key) {
    var p = DEMO_PRESETS[key];
    return !!p && Object.keys(p).every(function (k) {
      return (k === 'theme' ? theme.current : theme.demo[k]) === p[k];
    });
  };

  theme.applyPreset = function (key) {
    var p = DEMO_PRESETS[key];
    if (!p) return;
    theme.set(p.theme);
    Object.keys(p).filter(function (k) {
      return k !== 'theme';
    }).forEach(function (k) {
      theme.demo[k] = p[k];
    });
  }; // demo only: persist every demo picker change
  // eslint-disable-next-line no-new


  new Vue({
    data: {
      demo: theme.demo
    },
    watch: {
      demo: {
        deep: true,
        handler: function handler(value) {
          try {
            window.localStorage.setItem(DEMO_KEY, JSON.stringify(value));
          } catch (e) {// storage unavailable - choices still apply for this session
          }
        }
      }
    }
  });
  Vue.prototype.$theme = theme;
});